import { takeEvery, call, put, select, race, delay } from 'redux-saga/effects'
import { delays } from '../../lib/constants'
import { getAllTenders } from '../../lib/requests/routesRequests'
import { getCurrentLang, getToken, getDicionary } from '../selectors'
//TODO this logic is need not
export function* worker() {
  try {
    const currentLang = yield select(getCurrentLang)
    const token = yield select(getToken)
    const dic = yield select(getDicionary)

    const { result } = yield race({
      result: call(getAllTenders, token, currentLang),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && result.status === 200) {
      yield put({
        type: 'SET_ALL_TENDERS',
        payload: [...result.data.data],
      })
    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
    }
  } catch (e) {
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
    if (e.response && e.response.data.relogin) {
      yield put({ type: 'SAGA_LOGOUT' })
    }
    if (e.response && e.response.data.forwardTo) {
      yield put({
        type: 'REDIRECT_OUTSIDE',
        payload: e.response.data.forwardTo,
      })
    }
  }
}

export default function* myTenders() {
  yield takeEvery('GET_ALL_TENDERS', worker)
}
